import React from 'react';
import {StyledArticle} from "./styled";

const Article = (props) => {
    return (
        <StyledArticle className={"Article"}>
            <div>
                {props.children}
            </div>
        </StyledArticle>
    )
}

export default Article;
